import { Viewer } from "@toast-ui/react-editor";
import { useEffect, useRef } from "react";

type Props = {
  value: string;
  isDisabled?: boolean;
};

const MarkdownViewer = ({ value, isDisabled }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // task-list-item 클래스를 가진 요소들을 찾아서 클릭 이벤트 차단
    const taskItems = containerRef.current.querySelectorAll(".task-list-item");

    taskItems.forEach((item) => {
      // 클릭 이벤트 차단
      (item as HTMLElement).style.pointerEvents = "none";
    });
  }, [value]);

  return (
    <div
      ref={containerRef}
      className="base-markdown"
      // style={{ pointerEvents: isDisabled ? "none" : "auto" }}
    >
      {/* @ts-ignore*/}
      <Viewer initialValue={value} />
    </div>
  );
};

export default MarkdownViewer;
